import { render } from "./InvestigationPage.vue?vue&type=template&id=20fe47f0&scoped=true&ts=true"
import script from "./InvestigationPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvestigationPage.vue?vue&type=script&lang=ts&setup=true"

import "./InvestigationPage.vue?vue&type=style&index=0&id=20fe47f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fe47f0"],['__file',"src/pages/investigation/InvestigationPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20fe47f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20fe47f0', __exports__)) {
    api.reload('20fe47f0', __exports__)
  }
  
  module.hot.accept("./InvestigationPage.vue?vue&type=template&id=20fe47f0&scoped=true&ts=true", () => {
    api.rerender('20fe47f0', render)
  })

}


export default __exports__